import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Button from "../singlecomponents/Button";
import { News } from "../../compilers/news/News";
import { useTranslation } from "react-i18next";
import { getLocalisedNews } from "../../api/news";
import YellowDivider from "../dividers/YellowDivider";
import NewsCard from "./NewsCard";
import Skeleton from "react-loading-skeleton";

const NewsSection: React.FC = () => {
  const [news, setNews] = useState<News[]>([]);
  const [innerPage, setInnerPage] = useState<boolean>(false);
  const { i18n, ready, t } = useTranslation();
  const numberOfSkeletons = 6;

  //If the component is in the Inner News page then use the 'innerPage' bool to change h2 to h3
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.includes("catalogue")) setInnerPage(true);
  }, []);

  useEffect(() => {
    if (news) {
      setNews([]);
    }
    getLocalisedNews(i18n.language).then((response: News[]) =>
      setNews(response.slice(0, 6))
    );
  }, [i18n.language]);

  const getRecentNews = () => {
    if (news.length < 1) {
      return [...Array(numberOfSkeletons)].map((i) => {
        return (
          <div key={i} className="news-card-wrapper card shadow-sm">
            <Skeleton width={100} count={2} />
            <Skeleton width={200} />
          </div>
        );
      });
    }

    return news.map((item) => {
      return <NewsCard key={item.id} news={item} />;
    });
  };

  return (
    <div className="section-divider mt-3 mb-0 my-md-4 position-relative">
      <div className="title-container">
        {innerPage ? (
          <h3>
            {" "}
            {ready ? (
              t("zecafe-titlecard-news.title")
            ) : (
              <Skeleton width={100} />
            )}{" "}
          </h3>
        ) : (
          <h2>
            {" "}
            {ready ? (
              t("zecafe-titlecard-news.title")
            ) : (
              <Skeleton width={100} />
            )}{" "}
          </h2>
        )}
        <YellowDivider heading="h2" />
      </div>
      <div className="mobile-move-to-bottom">
        <Link to={`/${i18n.language}/cafe/news/catalogue`}>
          <Button
            name={t("zecafe-titlecard-news.link-title")}
            buttonWhite={true}
          />
        </Link>
      </div>
      <div className="news-card-container">{getRecentNews()}</div>
    </div>
  );
};

export default NewsSection;
